const indicatoriCodifica = /Ã|Â|â€|â€™|â€œ|â€˜|â€“|â€”|â€¦|ðŸ|�/g;

const contaErrori = (testo) => (String(testo).match(indicatoriCodifica) || []).length;

export function riparaTesto(value) {
  if (typeof value !== "string" || !indicatoriCodifica.test(value)) {
    indicatoriCodifica.lastIndex = 0;
    return value;
  }
  indicatoriCodifica.lastIndex = 0;

  let corrente = value
    .replaceAll("â€™", "’")
    .replaceAll("â€˜", "‘")
    .replaceAll("â€œ", "“")
    .replaceAll("â€", "”")
    .replaceAll("â€“", "–")
    .replaceAll("â€”", "—")
    .replaceAll("â€¦", "…")
    .replaceAll("Â·", "·")
    .replaceAll("Â€", "€")
    .replaceAll("Â", "");
  for (let tentativo = 0; tentativo < 3; tentativo += 1) {
    const codici = Array.from(corrente, (carattere) => carattere.charCodeAt(0));
    if (codici.some((codice) => codice > 255)) break;
    try {
      const corretto = new TextDecoder("utf-8", { fatal: true }).decode(new Uint8Array(codici));
      if (contaErrori(corretto) >= contaErrori(corrente)) break;
      corrente = corretto;
    } catch {
      break;
    }
  }
  return corrente;
}

export function riparaStruttura(value) {
  if (typeof value === "string") return riparaTesto(value);
  if (Array.isArray(value)) return value.map(riparaStruttura);
  if (value && typeof value === "object" && !(value instanceof Blob)) {
    return Object.fromEntries(Object.entries(value).map(([chiave, elemento]) => [chiave, riparaStruttura(elemento)]));
  }
  return value;
}
